var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRumizLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c37fae509"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.421875 171.222656 L 105.898438 171.222656 L 105.898438 233.445312 L 43.421875 233.445312 Z M 43.421875 171.222656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66598e7c93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.148438 176.078125 L 101.242188 176.078125 L 101.242188 228.554688 L 48.148438 228.554688 Z M 48.148438 176.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f9b031bcae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.648438 176.078125 L 93.671875 176.078125 C 97.8125 176.078125 101.171875 179.433594 101.171875 183.578125 L 101.171875 221.054688 C 101.171875 225.195312 97.8125 228.554688 93.671875 228.554688 L 55.648438 228.554688 C 51.507812 228.554688 48.148438 225.195312 48.148438 221.054688 L 48.148438 183.578125 C 48.148438 179.433594 51.507812 176.078125 55.648438 176.078125 Z M 55.648438 176.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3b5952bf0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.421875 141.554688 L 106 141.554688 L 106 171.222656 L 43.421875 171.222656 Z M 43.421875 141.554688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d0cdff1131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74.660156 141.554688 L 105.898438 171.222656 L 43.421875 171.222656 Z M 74.660156 141.554688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "edd2f97111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.296875 176.078125 L 162.386719 176.078125 L 162.386719 228.554688 L 109.296875 228.554688 Z M 109.296875 176.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a483025b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.796875 176.078125 L 154.820312 176.078125 C 158.960938 176.078125 162.320312 179.433594 162.320312 183.578125 L 162.320312 221.054688 C 162.320312 225.195312 158.960938 228.554688 154.820312 228.554688 L 116.796875 228.554688 C 112.652344 228.554688 109.296875 225.195312 109.296875 221.054688 L 109.296875 183.578125 C 109.296875 179.433594 112.652344 176.078125 116.796875 176.078125 Z M 116.796875 176.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5cd2cbbc2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 165.714844 176.09375 L 218.808594 176.09375 L 218.808594 228.574219 L 165.714844 228.574219 Z M 165.714844 176.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4f5b1504e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 173.214844 176.09375 L 211.238281 176.09375 C 215.378906 176.09375 218.738281 179.453125 218.738281 183.59375 L 218.738281 221.074219 C 218.738281 225.214844 215.378906 228.574219 211.238281 228.574219 L 173.214844 228.574219 C 169.074219 228.574219 165.714844 225.214844 165.714844 221.074219 L 165.714844 183.59375 C 165.714844 179.453125 169.074219 176.09375 173.214844 176.09375 Z M 173.214844 176.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c407ce940"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 222.136719 176.078125 L 275.226562 176.078125 L 275.226562 228.554688 L 222.136719 228.554688 Z M 222.136719 176.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd85d7ccd3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 229.636719 176.078125 L 267.660156 176.078125 C 271.800781 176.078125 275.160156 179.433594 275.160156 183.578125 L 275.160156 221.054688 C 275.160156 225.195312 271.800781 228.554688 267.660156 228.554688 L 229.636719 228.554688 C 225.492188 228.554688 222.136719 225.195312 222.136719 221.054688 L 222.136719 183.578125 C 222.136719 179.433594 225.492188 176.078125 229.636719 176.078125 Z M 229.636719 176.078125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7301c6d4a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 278.554688 176.09375 L 331.648438 176.09375 L 331.648438 228.574219 L 278.554688 228.574219 Z M 278.554688 176.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "82dc124e96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 286.054688 176.09375 L 324.078125 176.09375 C 328.21875 176.09375 331.578125 179.453125 331.578125 183.59375 L 331.578125 221.074219 C 331.578125 225.214844 328.21875 228.574219 324.078125 228.574219 L 286.054688 228.574219 C 281.914062 228.574219 278.554688 225.214844 278.554688 221.074219 L 278.554688 183.59375 C 278.554688 179.453125 281.914062 176.09375 286.054688 176.09375 Z M 286.054688 176.09375 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c37fae509)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde59",
    d: "M 43.421875 171.222656 L 105.886719 171.222656 L 105.886719 233.445312 L 43.421875 233.445312 Z M 43.421875 171.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66598e7c93)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f9b031bcae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5da5e0",
    d: "M 48.148438 176.078125 L 101.242188 176.078125 L 101.242188 228.554688 L 48.148438 228.554688 Z M 48.148438 176.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b5952bf0d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d0cdff1131)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e10022",
    d: "M 43.421875 141.554688 L 105.886719 141.554688 L 105.886719 171.222656 L 43.421875 171.222656 Z M 43.421875 141.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.638632, 217.891954)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.046875 0 L 17.171875 -8.5 L 10.671875 -8.5 L 10.671875 0 L 3.609375 0 L 3.609375 -30.5 L 16.828125 -30.5 C 19.523438 -30.5 21.867188 -30.046875 23.859375 -29.140625 C 25.847656 -28.242188 27.378906 -26.96875 28.453125 -25.3125 C 29.523438 -23.65625 30.0625 -21.695312 30.0625 -19.4375 C 30.0625 -17.164062 29.515625 -15.207031 28.421875 -13.5625 C 27.335938 -11.925781 25.796875 -10.675781 23.796875 -9.8125 L 30.640625 0 Z M 22.921875 -19.4375 C 22.921875 -21.144531 22.367188 -22.457031 21.265625 -23.375 C 20.160156 -24.289062 18.546875 -24.75 16.421875 -24.75 L 10.671875 -24.75 L 10.671875 -14.125 L 16.421875 -14.125 C 18.546875 -14.125 20.160156 -14.585938 21.265625 -15.515625 C 22.367188 -16.441406 22.921875 -17.75 22.921875 -19.4375 Z M 22.921875 -19.4375 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edd2f97111)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a483025b5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5da5e0",
    d: "M 109.296875 176.078125 L 162.386719 176.078125 L 162.386719 228.554688 L 109.296875 228.554688 Z M 109.296875 176.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5cd2cbbc2f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4f5b1504e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5da5e0",
    d: "M 165.714844 176.09375 L 218.808594 176.09375 L 218.808594 228.574219 L 165.714844 228.574219 Z M 165.714844 176.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c407ce940)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fd85d7ccd3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5da5e0",
    d: "M 222.136719 176.078125 L 275.226562 176.078125 L 275.226562 228.554688 L 222.136719 228.554688 Z M 222.136719 176.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7301c6d4a0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#82dc124e96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5da5e0",
    d: "M 278.554688 176.09375 L 331.648438 176.09375 L 331.648438 228.574219 L 278.554688 228.574219 Z M 278.554688 176.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.631075, 217.891954)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 17.171875 0.515625 C 12.816406 0.515625 9.425781 -0.6875 7 -3.09375 C 4.570312 -5.507812 3.359375 -8.953125 3.359375 -13.421875 L 3.359375 -30.5 L 10.421875 -30.5 L 10.421875 -13.6875 C 10.421875 -8.21875 12.6875 -5.484375 17.21875 -5.484375 C 19.425781 -5.484375 21.109375 -6.144531 22.265625 -7.46875 C 23.429688 -8.789062 24.015625 -10.863281 24.015625 -13.6875 L 24.015625 -30.5 L 30.984375 -30.5 L 30.984375 -13.421875 C 30.984375 -8.953125 29.769531 -5.507812 27.34375 -3.09375 C 24.914062 -0.6875 21.523438 0.515625 17.171875 0.515625 Z M 17.171875 0.515625 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.415518, 217.891954)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 31.375 0 L 31.328125 -18.296875 L 22.359375 -3.21875 L 19.171875 -3.21875 L 10.234375 -17.90625 L 10.234375 0 L 3.609375 0 L 3.609375 -30.5 L 9.453125 -30.5 L 20.875 -11.546875 L 32.109375 -30.5 L 37.90625 -30.5 L 38 0 Z M 31.375 0 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.492172, 217.891954)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.609375 -30.5 L 10.671875 -30.5 L 10.671875 0 L 3.609375 0 Z M 3.609375 -30.5 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.440842, 217.891954)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 28.328125 -5.75 L 28.328125 0 L 1.65625 0 L 1.65625 -4.578125 L 18.390625 -24.75 L 2 -24.75 L 2 -30.5 L 27.671875 -30.5 L 27.671875 -25.921875 L 10.984375 -5.75 Z M 28.328125 -5.75 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRumizLogo);
export default __webpack_public_path__ + "static/media/Rumiz_logo.ad70f20f908c439685203e8d44f8e597.svg";
export { ForwardRef as ReactComponent };